import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import {
  Paper, Box, TextField, Button, IconButton, Modal,
  Typography, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Select, MenuItem, InputLabel, FormControl
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import '../styles/AppStyle.css';
import { GetListMessages, UpdateMessage, CreateMessage, DeleteMessage } from '../Redux/MessageDucks';
import { fetchBusinessesFromAPI } from '../Redux/BusinessDucks';
import { useDispatch, useSelector } from 'react-redux'

const MessageConfigPage = ({ type }) => {
  const [Messages, setMessage] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState({});
  const [messageToDelete, setMessageToDelete] = useState(null);
  const [selectedBusinessLine, setSelectedBusinessLine] = useState("0");

  const dispatch = useDispatch()
  const messageList = useSelector(store => store.message.messages)
  const businessLineList = useSelector(store => store.business)

  useEffect(() => {
    fetchMessages();
    fetchBusinessLines()
  }, []);

  useEffect(() => {
    if (messageList && messageList.list) {
      setMessage(messageList.list);
      if (loading) {
        setLoading(false);
      }
    }
  }, [messageList]);

  const fetchMessages = () => {
    setLoading(true);
    dispatch(GetListMessages("0"));

  };

  const fetchBusinessLines = () => {
    setLoading(true);
    dispatch(fetchBusinessesFromAPI());
  };

  const filteredItems = Messages.filter(
    item => (item.message && item.message.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase()))
  );

  // IDs sincronizados con la tabla ResponsesTypes (1=text, 4=list, 5=buttons).
  const responseTypes = [
    { id: 1, name: 'Texto' },
    { id: 4, name: 'Lista' },
    { id: 5, name: 'Botones' },
  ];

  const handleViewDetail = (msg) => {
    setSelectedMessage(msg);
    setIsDetailModalOpen(true);
  };

  const handleAdd = () => {
    setSelectedMessage({
      name: '',
      message: '',
      responseType: 1,
      expected: '',
      businessLineId: 1
    });
    //setSelectedMessage({})
    setIsModalOpen(true);


  };

  const handleConfirmDelete = () => {
    if (messageToDelete && messageToDelete.id) {
      // Dispatch delete action here
      dispatch(DeleteMessage(messageToDelete.id));
      setIsDeleteDialogOpen(false);
      setMessageToDelete(null);
      //solucion temporal, actualizacion es mas lenta que el get
      setTimeout(() => {
        fetchMessages()
        setIsModalOpen(false)
      }, 500);
    }
  };

  const handleEdit = (msg) => {
    setSelectedMessage(msg);
    setIsModalOpen(true);
  };

  const handleSaveMessageItem = () => {
    try {
      if (selectedMessage && selectedMessage.id) {
        dispatch(UpdateMessage(selectedMessage))
      } else {
        //genera un nuevo mensaje a partir de los datos ingresados
        const newMessage = {
          name: selectedMessage.name,
          message: selectedMessage.message,
          responseType: selectedMessage.responseType,
          expected: selectedMessage.expected,
          businessLineId: selectedMessage.businessLineId
        };

        dispatch(CreateMessage(newMessage));

      }
      //solucion temporal, actualizacion es mas lenta que el get
      // setTimeout(() => {
      //   fetchMessages()
      //   setIsModalOpen(false)
      // }, 500);

      setIsModalOpen(false)

    } catch (err) {
    }
  }

  const handleDelete = (msg) => {
    setMessageToDelete(msg)
    setIsDeleteDialogOpen(true)
  };

  const getStatusText = (idStatus) => {
    return idStatus === 1 ? 'Activo' : 'Inactivo'
  };

  const getResponseTypeText = (id) => {
    const responseType = responseTypes.find((item) => item.id === id)
    return responseType ? responseType.name : 'Desconocido'
  };

  const getBusinessLineText = (id) => {
    const businessLine = businessLineList.find((item) => item.id === id);
    return businessLine ? businessLine.name : 'Desconocido';
  };

  const handleChange = (e) => {
    const { name, value } = e.target

    setSelectedMessage(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleResponseTypeChange = (event) => {
    const { value } = event.target;

    setSelectedMessage((prevState) => ({
      ...prevState,
      responseType: value,
    }));
  };

  const handleBusinessLineChange = (event) => {
    const { value } = event.target;

    setSelectedMessage((prevState) => ({
      ...prevState,
      businessLineId: value,
    }));
  }

  const handleChangeOption = (event) => {
    const { value } = event.target;
    setSelectedBusinessLine(value);
    setLoading(true);
    dispatch(GetListMessages(value));
  };

  const columns = [
    {
      name: 'ID',
      selector: row => row.id,
      sortable: true,
      maxWidth: "20px"
    },
    {
      name: 'Nombre',
      selector: row => row.name,
      sortable: true,
      maxWidth: "200px"
    },
    {
      name: 'Mensaje',
      selector: row => row.message,
      sortable: true,
      grow: 2,
      maxWidth: "900px"
    },
    {
      name: 'Tipo de Mensaje',
      selector: row => getResponseTypeText(row.responseType),
      sortable: true,
    },
    {
      name: 'Línea de Negocio',
      selector: row => getBusinessLineText(row.businessLineId),
      sortable: true,
    },
    {
      name: 'Acciones',
      cell: row => (
        <Box>
          <IconButton onClick={() => handleViewDetail(row)} size="small" className="apple-button apple-tooltip">
            <VisibilityIcon fontSize="small" />
            <span className="tooltiptext">Ver Detalle</span>
          </IconButton>
          <IconButton onClick={() => handleEdit(row)} size="small" className="apple-button apple-tooltip">
            <EditIcon fontSize="small" />
            <span className="tooltiptext">Editar</span>
          </IconButton>
          <IconButton onClick={() => handleDelete(row)} size="small" className="apple-button apple-tooltip">
            <DeleteIcon fontSize="small" />
            <span className="tooltiptext">Eliminar</span>
          </IconButton>
        </Box>
      ),
    },
  ];

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <Box className="apple-card" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <div className="apple-search-container">
        <SearchIcon className="apple-search-icon" />
        <input
          type="text"
          placeholder="Buscar por nombre o mensaje"
          onChange={e => setFilterText(e.target.value)}
          className="apple-search-input"
        />
        </div>
        <FormControl variant="outlined" className="apple-select" sx={{ ml: 2 }} fullWidth>
        <InputLabel id="business-line-label">Línea de Negocio</InputLabel>
        <Select
          labelId="business-line-label"
          label="Línea de Negocio"
          value={selectedBusinessLine}
          onChange={handleChangeOption}
        >
          <MenuItem value={"0"}>Todos</MenuItem>
          {businessLineList.map((option) => (
          <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
          ))}
        </Select>
        </FormControl>
      </Box>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleAdd}
        className="apple-button"
      >
        Agregar Mensaje
      </Button>
      </Box>
    );
  }, [filterText, selectedBusinessLine, businessLineList]);


  return (
    <div className="apple-container" >
      <Paper className="apple-card">
        <DataTable
          columns={columns}
          data={filteredItems}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          progressPending={loading}
          persistTableHead
          customStyles={customStyles}
        />
      </Paper>

      {/* Modal para editar/crear rol
             {id:"01", message:"bienvenido a grupo Defensa", type: "text", data:[], expectedResponse: ["any"] },
        */}
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="apple-modal" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '40%',
          maxHeight: '100vh'
        }}>
          <center>
            <Typography variant="h6" id="modal-modal-title" className="apple-modal-title">
              {selectedMessage.id ? 'Editar Mensaje' : 'Agregar Nuevo Mensaje'}
            </Typography>
          </center>
          <div className="apple-modal-content" style={{ overflow: 'auto',  maxHeight: '80vh', paddingTop: '10px' }}>
            <TextField
              name="name"
              label="Nombre"
              variant="outlined"
              fullWidth
              className="apple-input"
              defaultValue={selectedMessage.name || ''}
              onChange={handleChange}
            />
            <TextField
              name='message'
              label="Mensaje"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              className="apple-input"
              defaultValue={selectedMessage.message || ''}
              onChange={handleChange}
            />
            <FormControl fullWidth variant="outlined" className="apple-input">
              <InputLabel id="response-type-label">Tipo de mensaje</InputLabel>
              <Select
                labelId="response-type-label"
                label="Tipo de mensaje"
                value={selectedMessage.responseType || 1}
                onChange={handleResponseTypeChange}
              >
                {responseTypes.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth variant="outlined" className="apple-input">
              <InputLabel id="business-line-label">Línea de Negocio</InputLabel>
              <Select
                labelId="business-line-label"
                label="Línea de Negocio"
                value={selectedMessage.businessLineId || 1}
                onChange={handleBusinessLineChange}
              >
                {businessLineList.map((option) => (
                  <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              name="expected"
              label="Respuesta Esperada"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              className="apple-input"
              defaultValue={selectedMessage.expected || ''}
              onChange={handleChange}
            />
          </div>
          <div className="apple-modal-footer">
            <Button onClick={() => setIsModalOpen(false)} className="apple-button">
              Cancelar
            </Button>
            <Button variant="contained" className="apple-button"
              onClick={() => handleSaveMessageItem()}
            >
              {selectedMessage.id ? 'Guardar Cambios' : 'Crear Mensaje'}
            </Button>
          </div>
        </Box>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal
        open={isDetailModalOpen}
        onClose={() => setIsDetailModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="apple-modal" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
        }}>
          <center>
            <Typography variant="h6" id="modal-modal-title" className="apple-modal-title">
              Detalles del Mensaje
            </Typography>
          </center>
          <div className="apple-modal-content">
            <TextField
              label="ID"
              fullWidth
              value={selectedMessage?.id}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label="ID"
              fullWidth
              value={selectedMessage?.name}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label="Mensaje"
              fullWidth
              value={selectedMessage?.message}
              rows={4}
              multiline
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label="tipo de Mensaje"
              fullWidth
              value={getResponseTypeText(selectedMessage?.responseType)}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
            <TextField
              label="Linea de Negocio"
              fullWidth
              value={getBusinessLineText(selectedMessage?.businessLineId)}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />

            <TextField
              label="Respuesta esperada"
              fullWidth
              value={selectedMessage?.expected}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
          </div>
          <div className="apple-modal-footer">
            <Button onClick={() => setIsDetailModalOpen(false)} className="apple-button">
              Cerrar
            </Button>
          </div>
        </Box>
      </Modal>

      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setIsDeleteDialogOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmar Eliminación"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Está seguro de que desea eliminar el mensaje seleccionado?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsDeleteDialogOpen(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>


    </div>
  );
}

const customStyles = {
  table: {
    style: {
      minWidth: '80vw',
      maxWidth: '90vw'
    },
  },
  headRow: {
    style: {
      backgroundColor: '#F2F2F7',
      borderBottom: 'none',
    },
  },
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: '600',
      color: '#86868B',
      textTransform: 'uppercase',
    },
  },
  cells: {
    style: {
      fontSize: '14px',
      color: '#1D1D1F',
    },
  },
};
export default MessageConfigPage